{
    "notes__delete_confirmation__title": "Supprimer l'interaction",
    "notes__delete_confirmation__description": "L'interaction sera définitivement supprimée. Cette action est irréversible.",
    "notes__form_create_title": "Enregistrer une interaction",
    "notes__form_create_toast__success_title": "Interaction enregistrée avec succès",
    "notes__tasks_section_title": "Tâches",
    "notes__tasks_assignee_me": "Moi",
    "notes__tasks_quick_action_call": "Appeler",
    "notes__tasks_quick_action_clarify_price": "Clarifier le prix",
    "notes__tasks_quick_action_task": "Tâche",
    "notes__tasks_summary_open": "ouvertes",
    "notes__tasks_summary_completed": "terminées",
    "notes__offers_section_title": "Devis ouverts",
    "notes__offers_section_empty": "Aucun devis ouvert",
    "notes__offers_section_summary_one": "{{count}} ouvert · {{total}}",
    "notes__offers_section_summary_many": "{{count}} ouverts · {{total}}",
    "notes__offers_section_summary_other": "{{count}} ouverts · {{total}}",
    "notes__offers_section_loading": "Chargement des devis…",
    "notes__offers_draft_title": "Brouillon",
    "notes__offers_draft_state": "Brouillon",
    "notes__ai_insights_section_title": "Recommandations commerciales",
    "notes__ai_insights_section_empty": "Aucune recommandation commerciale",
    "notes__ai_insights_section_loading": "Chargement des recommandations…",
    "notes__ai_insights_show_more_one": "{{count}} de plus",
    "notes__ai_insights_show_more_many": "{{count}} de plus",
    "notes__ai_insights_show_more_other": "{{count}} de plus",
    "notes__ai_insights_more_articles_one": "{{count}} autre article",
    "notes__ai_insights_more_articles_many": "{{count}} autres articles",
    "notes__ai_insights_more_articles_other": "{{count}} autres articles",
    "notes__ai_insights_outcome_action": "Ajouter une réponse",
    "notes__ai_insights_outcome_none": "Aucune",
    "notes__offers_quote_title": "Devis {{displayId}}",
    "notes__offers_positions_count_one": "{{count}} poste",
    "notes__offers_positions_count_many": "{{count}} postes",
    "notes__offers_positions_count_other": "{{count}} postes",
    "notes__offers_positions_more_one": "{{count}} autre poste",
    "notes__offers_positions_more_many": "{{count}} autres postes",
    "notes__offers_positions_more_other": "{{count}} autres postes",
    "notes__offers_margin_label": "Marge",
    "notes__offers_kommission": "N° cde {{number}}",
    "notes__offers_task_action": "Tâche",
    "notes__offers_confirm_suggestion": "Marquer comme terminé",
    "notes__offers_lost_suggestion": "Marquer comme perdu",
    "notes__offers_confirm_task": "Marquer {{offer}} comme terminé",
    "notes__offers_lost_task": "Marquer {{offer}} comme perdu",
    "notes__form_edit_title": "Modifier l'interaction",
    "notes__form_edit_save": "Enregistrer",
    "notes__form__follow_ups_title": "Activités",
    "notes__form_edit_toast__success_title": "Interaction mise à jour avec succès",
    "notes__delete_confirmation__toast__success_title": "Interaction supprimée",
    "notes__delete_confirmation__toast__success_description": "L'interaction a été supprimée avec succès",
    "notes__type__visit": "Compte rendu",
    "notes__type__visit_not_reached": "Visite, client non joint",
    "notes__type__phone_call": "Appel",
    "notes__type__phone_call_not_reached": "Appel, client non joint",
    "notes__type__note": "Note",
    "notes__not_reached__active_label": "Client non joint",
    "notes__not_reached__back": "Retour",
    "notes__not_reached__reason_placeholder": "Motif (facultatif)",
    "notes__not_reached__submit": "Enregistrer comme non joint",
    "notes__placeholder__event": "Comment ça s'est passé ? De quoi avez-vous discuté ?",
    "notes__placeholder__phone_call": "Enregistrer l'appel…",
    "notes__placeholder__note": "Enregistrer la note…",
    "notes__form__customer_label": "Client",
    "notes__form__event_label": "Rendez-vous",
    "notes__form__date_label": "Date",
    "notes__form__time_label": "Heure",
    "notes__form__date_prefill_source": "D'après le dernier rendez-vous",
    "notes__form__last_event": "Dernier rendez-vous",
    "notes__form__date_now": "Maintenant",
    "notes__form__date_clear": "Effacer la date",
    "notes__form__protokoll_label": "Compte rendu",
    "notes__pin_note": "Épingler la note",
    "notes__pinned_label": "Épinglée",
    "notes__pin_success_toast": "Note épinglée avec succès",
    "notes__unpin_success_toast": "Note désépinglée avec succès",
    "notes__pin_confirmation_title": "Note déjà épinglée",
    "notes__pin_confirmation_description": "Une seule note peut être épinglée à la fois. Voulez-vous épingler celle-ci à la place ?",
    "notes__pin_confirmation_cancel": "Annuler",
    "notes__pin_confirmation_confirm": "Épingler la note"
}
